import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { ManagerDashboardResponse } from "../types";
import { queryKeys } from "./queryKeys";

const fetchManagerDashboard = async (): Promise<ManagerDashboardResponse> => {
  const { data } = await axios.get("/api/manager/dashboard");
  return data;
};

/**
 * One request for the whole page, so the dashboard has a single loading state
 * rather than assembling itself in eight jerks.
 */
export const useManagerDashboard = () =>
  useQuery<ManagerDashboardResponse>({
    queryKey: [queryKeys.MANAGER_DASHBOARD],
    queryFn: fetchManagerDashboard,
  });
